import { DeleteVariantIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import st from './DeletePermissionTagsConfirmation.module.sass';

interface DeletePermissionTagsConfirmationProps extends WithDataTestid {
  onConfirm: VoidFunction;
  onReject: VoidFunction;
}

function DeletePermissionTagsConfirmation({
  onConfirm,
  onReject,
  'data-testid': dataTestId = undefined,
}: DeletePermissionTagsConfirmationProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      className={st.DeletePermissionTagsConfirmation}
      data-testid={dataTestId}
    >
      <div className={st.Header}>
        <DeleteVariantIcon className={st.Icon} />
        <div className={st.Description}>
          <span className={st.Title}>{t('features:delete_permission_tags.confirmation.title')}</span>
          <span className={st.Subtitle}>{t('features:delete_permission_tags.confirmation.subtitle')}</span>
        </div>
      </div>

      <div className={st.Actions}>
        <Control.Button
          className={st.Action}
          kind="secondary"
          onClick={onReject}
          variant="outlined"
        >
          {t('features:delete_permission_tags.confirmation.buttons.cancel')}
        </Control.Button>
        <Control.Button
          className={st.Action}
          kind="negative"
          onClick={onConfirm}
          variant="filled"
        >
          {t('features:delete_permission_tags.confirmation.buttons.delete')}
        </Control.Button>
      </div>
    </div>
  );
}

export { DeletePermissionTagsConfirmation };
